<template>
  <div class="lokakarya">
    <v-card flat>
      <v-card-title>
        <h4 class="black--text">Daftar Laporan Pendampingan Kelompok</h4>
      </v-card-title>
      <v-divider />
      <v-card-title class="pa-0">
        <base-table-header
          :options="{ header: 'py-2' }"
          :btnAdd="$allow('psp-peserta-kp-lokakarya.create') && gelombang < 2"
          @add="onAdd"
          @reload="onReload"
          @search="onSearch"
        >
          <template v-slot:subtitle>
            <div class="body-1 black--text">
              Jumlah Data <span class="blue--text font-weight-medium">{{ total }}</span>
            </div>
          </template>
          <template v-slot:toolbar>
            <div style="max-width: 350px">
              <v-row no-gutters>
                <v-col cols="12" lg="6" class="py-2 pr-1">
                  <v-select
                    v-model="gelombang"
                    light
                    flat
                    dense
                    outlined
                    hide-details
                    :items="mGelombang"
                    @change="onChangeGelombang"
                  ></v-select>
                </v-col>
                <v-col cols="12" lg="6" class="py-2">
                  <v-select
                    v-model="tahunKe"
                    light
                    flat
                    dense
                    outlined
                    hide-details
                    :items="mTahun"
                    @change="onChangeTahun"
                  ></v-select>
                </v-col>
              </v-row>
            </div>
          </template>
        </base-table-header>
      </v-card-title>
      <v-divider />
      <v-card-text>
        <component
          :is="+tahunKe === 1 && +gelombang === 1 ? 'ListKpLokakarya' : 'ListPendampinganLokakarya'"
          :data="data"
          :loading="loading"
          :total="total"
          :actions="actions"
          :allow="allow"
          @fetch="fetchData"
          @action="onAction"
          @detail="onDetail"
        />
      </v-card-text>
      <v-card-actions>
        <base-table-footer :pageTotal="pageTotal" :allow="!allow" @changePage="onChangePage"></base-table-footer>
      </v-card-actions>
      <base-modal-full ref="modal" :useSave="formulir.useSave" :title="formulir.title" @save="onSave">
        <component
          ref="formulir"
          :is="formulir.form"
          :initValue="formulir.init"
          :isEdit="formulir.isEdit"
          :readOnly="formulir.readOnly"
          :detail="formulir.detail"
          :masters="masters"
          :isPelapor="formulir.isPelapor"
          @refresh="onEdit"
        />
      </base-modal-full>
    </v-card>
  </div>
</template>

<script>
import list from '@mixins/list';
import mixin from './mixin';
import FormKelompok from './component/Form';
import ListKpLokakarya from './list/KpLokakarya';
import ListPendampinganLokakarya from './list/PendampinganLokakarya';
import { mapState } from 'vuex';
import actions from './actions';
export default {
  components: { FormKelompok, ListKpLokakarya, ListPendampinganLokakarya },
  mixins: [list, mixin],
  data() {
    return {
      formulir: {},
      actions: actions,
      gelombang: 2,
      tahunKe: 1,
    };
  },
  created() {
    const gelombangs = this.$getDeepObj(this.configPendampingan, 'kp-pa.gelombang') || [];
    const tahunKe = this.$getDeepObj(this.configPendampingan, 'kp-pa.tahun_ke') || {};
    const [gelombang] = [...[], ...gelombangs].slice(-1);

    this.gelombang = gelombang;
    this.tahunKe = tahunKe[gelombang] || '';

    this.fetchData();
  },
  computed: {
    ...mapState('master', ['masters']),
    ...mapState('preferensi', {
      preferensi: (state) => state.data,
      configPendampingan: (state) => (state.data && state.data.pendampingan) || {},
    }),

    mGelombang() {
      const gelombangs = this.$getDeepObj(this.configPendampingan, 'kp-pa.gelombang') || [];
      return [...[], ...gelombangs].reverse().map((value) => {
        return {
          text: `Angkatan ${value}`,
          value,
        };
      });
    },

    mTahun() {
      const tahunKe = this.$getDeepObj(this.configPendampingan, 'kp-pa.tahun_ke') || {};
      let tahuns = [];
      for (let i = 1; i <= tahunKe[this.gelombang]; i++) {
        tahuns.push(i);
      }

      return tahuns.reverse().map((value) => {
        return {
          text: `Tahun Ke-${value}`,
          value,
        };
      });
    },
  },
};
</script>
